import type { PlatformId } from 'frontend-platform_detection';
import type { Request } from 'express';
import { CookieNames, StepType } from '../../services/types';

export const isMP = (platform: PlatformId) => platform === 'MP';
export const isML = (platform: PlatformId) => platform === 'ML';

export const isSwapStep = (step: StepType) => [StepType.KYCWithSession, StepType.TyCWithSession, StepType.PhoneValidationWithSession].includes(step);

export const isSwapCompleteStep = (req: Request, { step }: { step: StepType }) => {
  if (isMP(req.platform!.id) && req.cookies[CookieNames.ParityV3] && req.auth?.user?.id) {
    return isSwapStep(step);
  }
  return false;
};
